import dynamic from "next/dynamic";

export const DynamicHero033 = dynamic(() => import("./Hero033"), {
  suspense: true,
});
